import { render } from "./Parallax.vue?vue&type=template&id=3805c2d4&scoped=true"
const script = {}

import "./Parallax.vue?vue&type=style&index=0&id=3805c2d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3805c2d4"]])

export default __exports__